'use client';
import { Box, Stack } from '@mui/material';
import ServiceElement from './ServiceElement';
import { useState } from 'react';
import { AccordionType } from '../type';
import DarkThemeProvider from '../../../../providers/DarkThemeProvider';
import OpenElement from './OpenElement';
import LightThemeProvider from '../../../../providers/LightThemeProvider';

type Props = {
  data: AccordionType;
  isMobile: boolean;
};

/* DESKTOP only */
const FullVerticalAccordion = ({ data }: Props) => {
  const { elements, styling } = data;
  const [selected, setSelected] = useState(0);
  const ThemeProvider = styling.isDark ? DarkThemeProvider : LightThemeProvider;
  return (
    <ThemeProvider>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'stretch',
          justifyContent: 'stretch',
          ...styling.sx,
        }}
      >
        <Stack>
          {elements.map((item, index) => {
            return (
              <ServiceElement
                key={`${item.title}_${index}`}
                title={item.title}
                isOpen={index === selected}
                onClick={() => setSelected(index)}
              />
            );
          })}
        </Stack>
        <Box
          sx={{
            display: 'grid',
          }}
        >
          {elements.map((item, index) => {
            return (
              <OpenElement
                key={`${item.title}_${index}`}
                isOpen={index === selected}
                description={item.description}
                palletMode={styling.isOpenDark ? 'dark' : 'light'}
              />
            );
          })}
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default FullVerticalAccordion;
